import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerService } from '@services/customers/customer.service';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';
import { DataTableEvent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'customer-selection',
    templateUrl: './customer-selection.component.html',
    styleUrls: ['./customer-selection.component.scss'],
    providers: [CustomerService, OrganisationCustomerService],
    standalone: false
})
export class CustomerSelectionComponent implements OnInit {

  public customerType: string;
  public selectedCustomerId: string = null;
  public angieOnly: false;

  public columnsIbex3 = [
    { prop: 'company' },
    { prop: 'name.firstName', name: 'Firstname' },
    { prop: 'name.lastName', name: 'Lastname' },
    { validate: '_id', name: 'Selected', icon: 'check_box' }
  ];
  public columnsOrganisationCustomer = [
    { prop: 'organisationName' },
    { prop: 'name.firstName', name: 'Firstname' },
    { prop: 'name.lastName', name: 'Lastname' },
    { validate: '_id', name: 'Selected', icon: 'check_box' }
  ];

  constructor(
    public dialogRef: MatDialogRef<CustomerSelectionComponent>,
    public customerService: CustomerService,
    public organisationCustomerService: OrganisationCustomerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
    this.customerType = 'organisationCustomer';
    this.angieOnly = this.data.angieOnly || false;
  }

  onSelect(event: DataTableEvent) {
    const customerId = !event ? null : event.row._id;
    let data = null;
    if (!event.row.isValidated) {
      data = {
        customerId: customerId,
        customerType: this.customerType
      }
    }
    this.dialogRef.close(data);
  }

  abort() {
    this.dialogRef.close();
  }

}
